import useFetch from '@hooks/useFetch';
import { HOST_TYPE } from '@utils/api-helper/host';

const useCertificationCourseData = (
  goalUID,
  options = { fallbackData: undefined }
) => {
  const key = `api/programme-details/${goalUID}`;
  const { data, mutate, ...rest } = useFetch(
    key,
    { useCamelCase: true, hostType: HOST_TYPE.CMS },
    { fallbackData: options.fallbackData }
  );
  return {
    key,
    formQuestions: data?.formQuestions ?? {},
    overAll: data?.overAll ?? {},
    sections: data?.sections ?? {},
    mutate,
    ...rest
  };
};

export default useCertificationCourseData;
